import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Branch } from 'src/app/@shared/models/filial.model';
import { FilialOutput } from 'src/app/@shared/models/filial.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class FilialService {

  constructor(private http: HttpClient) { }

  getList(): Observable<Branch[]> {
    return this.http.get<Branch[]>(`Filial/ListarFilial`, httpOptions);
  }

  listarFilialDestino(): Observable<Branch[]> {
    return this.http.get<Branch[]>(`Filial/ListarFilialDestino`, httpOptions);
  }

  listarFiliaisGeracaoManifesto(): Observable<HttpResponse<FilialOutput[]>> {
    return this.http.get<FilialOutput[]>(`Filial/ListarFiliaisGeracaoManifesto`, { observe: 'response' })
  }

}
